import {
  FilterGroupState,
  FilterRowState,
} from "features/ui/Filters/FilterBuilder/types";
import { getFiltersQuery } from "features/ui/Filters/FilterBuilder/utils";
import { FilterOperator } from "features/ui/Filters/types";

// Builds the `name == Y` filter used to resolve a schema definition by its
// name. A definition's name is unique per tenant (DB unique index on
// (tenant, name)), so name alone — without tableType — resolves to exactly one
// definition. Replaces the former tableType+name getSchemaFilter; kept local to
// avoid a shared -> pages import.
export const getSchemaNameFilter = (name: string): string => {
  const nameFilter: FilterRowState = {
    type: "row",
    id: "row-0",
    attribute: "name",
    operator: FilterOperator.EQUALS,
    values: [name],
  };
  const group: FilterGroupState = {
    type: "group",
    id: "group-0",
    anyAll: "all",
    children: [nameFilter],
  };

  return getFiltersQuery(group);
};
